import { writable } from "svelte/store";
/**
 *    simple use:
 *
 *    // show loader
 *    const loadId = $loader.show();
 *
 *    // show loader with a message
 *    const loadId = $loader.show("The task is running, please wait a few minutes ...");
 *
 *    // hide loader
 *    $loader.hide(loadId);
 *
 *    You can show multiple loader as you want and hidden their with their process id.
 *    When all process id are hidden, the loader will automatically take out himself.
 */
export class Loader {
    constructor() {
        this._loading = false;
        this._loadingWritable = writable(false);
        this._messagesWritable = writable([]);
        this._processList = [];
    }
    /**
     * Return the loading status in live
     * simple use:
     * $: loading = $loader.loading;
     */
    get loading() {
        this._loadingWritable.set(this._loading);
        return this._loadingWritable;
    }
    /**
     * Return the message list in subscription
     * simple use:
     * $: messages = $loader.messages;
     */
    get messages() {
        this._messagesWritable.set(this._processList.filter(e => e.msg !== "").map(e => e.msg));
        return this._messagesWritable;
    }
    /**
     * Show the loading and add a process id in a load's list.
     * [optional] - you can show a message.
     * Return the process id then you will need for hide it.
     */
    show(msg) {
        return this.addProcess(msg);
    }
    /**
     * Hide the loading corresponding the the process id.
     * If they are multiple loading showed, remove this process id on the load list.
     * @param processId: string
     */
    hide(processId) {
        this.removeProcess(processId);
    }
    // PRIVATE =========================================
    /**
     * Set the loading true if the load list have a process id.
     * @private
     */
    defineLoadingStatus() {
        this._loading = this._processList.length > 0;
        this._loadingWritable.set(this._loading);
        this._messagesWritable.set(this._processList.filter(e => e.msg !== "").map(e => e.msg));
    }
    /**
     * Add a process id in the load list
     * @private
     */
    addProcess(msg = "") {
        let processId = this.newProcessId();
        this._processList.push({ id: processId, msg });
        this.defineLoadingStatus();
        return processId;
    }
    /**
     * Remove a process id in the load list
     * @param processId
     * @private
     */
    removeProcess(processId) {
        let index = this.checkProcessList(processId);
        if (index >= 0) {
            this._processList.splice(index, 1);
        }
        this.defineLoadingStatus();
    }
    /**
     * Verify if the process id is in the load list.
     * @param processId
     * @private
     */
    checkProcessList(processId) {
        return this._processList.findIndex(e => e.id === processId);
    }
    /**
     * Create a new and unique process id.
     * @private
     */
    newProcessId() {
        const mathRdm = () => { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1); };
        let processId = mathRdm() + mathRdm() + "-" + mathRdm() + "-" + mathRdm() + mathRdm() + "-" + mathRdm();
        const isExist = this.checkProcessList(processId) >= 0;
        if (isExist || Number(processId) <= 0) {
            processId = this.newProcessId();
        }
        return processId;
    }
}
